import { useUpdatePersonPrivateInfo } from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';
import { PrivateInformationFormSchemaType } from '../usePrivateInformationFormSchema';

const TRANS_KEY = 'NOTIFICATIONS.UPDATE_PERSON_PRIVATE_INFORMATION';

type UpdatePersonPrivateInformationArgsType = {
  personId: string;
  onSuccessCallback?: () => void;
};

type UseUpdatePrivateInformationReturnType = {
  updatePersonPrivateInformation: (data: {
    formData: PrivateInformationFormSchemaType;
  }) => Promise<void>;
};

export const useUpdatePrivateInformation = ({
  personId,
  onSuccessCallback,
}: UpdatePersonPrivateInformationArgsType): UseUpdatePrivateInformationReturnType => {
  const { mutateAsync } = useUpdatePersonPrivateInfo();
  const { showSuccess, showError } = useNotification();

  const onSuccess = () => {
    showSuccess({
      title: `${TRANS_KEY}.SUCCESS.TITLE`,
      message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
    });
    onSuccessCallback?.();
  };

  const onError = (error: AxiosError) => {
    showError({
      title: `${TRANS_KEY}.ERROR.TITLE`,
      message: `${TRANS_KEY}.ERROR.MESSAGE`,
      error,
    });
  };

  const updatePersonPrivateInformation = async ({
    formData,
  }: {
    formData: PrivateInformationFormSchemaType;
  }) => {
    await mutateAsync(
      {
        id: personId,
        data: formData,
      },
      {
        onSuccess,
        onError,
      }
    );
  };

  return { updatePersonPrivateInformation };
};
